import * as React from 'react'
import  Login  from "../../components/Login/Login"


export const LoginInner = (props: any) =>
    <div>
        <Login/>
    </div>


// WEBPACK FOOTER //
// ./src/Routes/Login/LoginInner.tsx